export class PaymentMethodFeeType {
  public constructor() {
    this.FeeTypeId = 0;
    this.FeeType = '';
  }

  public FeeTypeId: number;
  public FeeType: string;
}
